import { createFileRoute } from '@tanstack/react-router'
import { ContentReportsPage } from '~/features/admin/content-reports-page'

export const Route = createFileRoute('/admin/content-reports')({
  component: ContentReportsPage,
})
